'use strict';

/* 
  Tray Promo Banner

  Contentful 
    EntityID: 61pyoAMWSYPi34V0o4H1VX
    SpaceID: 5s3ysw7vjfxb
    Snapshot: app/content/snapshots/master/entry-61pyoAMWSYPi34V0o4H1VX.json (was a Contentful entry, LOAN-490)

  As of July 2021, this tray is being made a multi-purpose contentful-driven tray to promote
  different products (Card product, upcoming Trade product etc) instead of downloading the app only
  hence the rename to tray-promo-banner.pug / TrayPromoBanner.js / tray-promo-banner.scss
  https://mogofintech.atlassian.net/browse/DV-2772
*/

function TrayPromoBanner() {
  this.id = null;
  this.node = null;
  this.extends = [];
  this.contentfulEntryID = '61pyoAMWSYPi34V0o4H1VX';

  this.init = function () {
    var requiredContent = this.presenter.getModelProperty('content.id_' + this.contentfulEntryID);

    this.genericLayoutNodeRef = this.node.getElementsByClassName('js--ui-generic-layout')[0]; // Cache Node var
    this.contentfulPromise = this.genericLayoutNodeRef.mogo().contentfulPromise; // Cache Promise var - This is defined in GenericLayout.js

    if (typeof requiredContent === 'undefined') {
      $.when(this.contentfulPromise).then(this._onContentLoaded.bind(this));
    } else {
      this._onContentLoaded();
    }
  };

  this._onContentLoaded = function () {
    this.requiredContent = this.presenter.getModelProperty('content.id_' + this.contentfulEntryID);

    if (!this.requiredContent) console.warn('TrayPromoBanner.js: unable to retrieve content model for Contentful Entry ID - ' + this.contentfulEntryID);

    var backgroundColor = this.requiredContent.configuration.backgroundColor; // At this point content from contentful is already cached and accessible via presenter

    this.genericLayoutNodeRef.style.background = backgroundColor; // Set the background color of the container dynamically via contentful configuration object
    this.genericLayoutNodeRef.mogo().pushContentfulAnalyticsEvent(); // Push analytics
  };

  this.initAllReady = function () {
    this.node.classList.add('active');
  };

  this.destroy = function () {};
}